var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ourdesc-page"},[_c('img',{staticClass:"ourdesc-page-img",attrs:{"src":"https://i.gsxcdn.com/2373363763_yxootf3t.jpg"}})])}]

export { render, staticRenderFns }